<template>
    <!--
      作者：kmdshop
      时间：2019-10-25
      描述：订单详情
  -->
    <div class="pb50" v-loading="loading">
        <!--订单进度-->
        <!-- <el-steps :active="active" finish-status="success">
        <el-step title="下单时间"></el-step>
        <el-step title="付款"></el-step>
        <el-step title="发货"></el-step>
        <el-step title="收货"></el-step>
        <el-step title="完成"></el-step>
        </el-steps> -->
        <!--内容-->
        <div class="product-content">
            <!--基本信息-->
            <div class="common-form">基本信息</div>
            <div class="table-wrap">
                <el-row>
                    <el-col :span="5">
                        <div class="pb16">
                            <span class="gray9">买家：</span>
                            {{ detail.user.nickName }}
                            <span>用户ID：({{ detail.user.user_id }})</span>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="pb16">
                            <span class="gray9">订单金额 (元)：</span>
                            {{ detail.total_price }}
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="pb16">
                            <span class="gray9">运费金额 (元)：</span>
                            {{ detail.express_price }}
                        </div>
                    </el-col>
                    <el-col :span="5" v-if="detail.discount_price">
                        <div class="pb16">
                            <span class="gray9">优惠金额 (元)：</span>
                            {{ detail.discount_price }}
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="pb16">
                            <span class="gray9">实付款金额 (元)：</span>
                            {{ detail.total_pay_price }}
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="pb16">
                            <span class="gray9">支付状态:</span>
                            {{ detail.pay_status == 0?'未支付' : '已支付' }}
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="pb16">
                            <span class="gray9">接单时间:</span>
                            {{timestampToTime(detail.accept_time)}}
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="pb16">
                            <span class="gray9">取消时间:</span>
                            {{timestampToTime(detail.cancel_time)}}
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="pb16">
                            <span class="gray9">完成时间:</span>
                            {{timestampToTime(detail.completion_time)}}
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="pb16">
                            <span class="gray9">生产期限:</span>
                            {{timestampToTime(detail.production_deadline)}}
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="pb16">
                            <span class="gray9">送货期限:</span>
                            {{timestampToTime(detail.goods_deadline)}}
                        </div>
                    </el-col>

                </el-row>
            </div>

            <div class="common-form mt16" v-if="detail.address">收货地址</div>
            <div class="table-wrap" v-if="detail.address">
                <el-row>
                    <el-col :span="15">
                        <div class="pb16">
                            <span class="gray9">收货地址：</span>
                            {{ detail.address.detail }}
                        </div>
                    </el-col>
                    <el-col :span="15">
                        <div class="pb16">
                            <span class="gray9">收货人：</span>
                            {{ detail.address.name }}
                        </div>
                    </el-col>
                    <el-col :span="15">
                        <div class="pb16">
                            <span class="gray9">联系电话：</span>
                            {{ detail.address.phone }}
                        </div>
                    </el-col>
                </el-row>
            </div>

            <div class="common-form mt16">订单详情</div>
            <div class="table-wrap">
                <el-row>
                    <el-col :span="15">
                        <div class="pb16">
                            <span class="gray9">订单号：</span>
                            {{ detail.order_sn }}
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-table :data="detail.horderProducts" style="width: 100%">
                        <el-table-column prop="order_sn" label="商品图片">
                            <template slot-scope="scope">
                                <img style="width: 50px;height: 50px;" :src="scope.row.image" alt="" />
                            </template>
                        </el-table-column>
                        <el-table-column prop="order_sn" label="子订单号">
                        </el-table-column>
                        <el-table-column prop="name" label="商品名称">
                        </el-table-column>
                        <el-table-column prop="length" label="尺寸(长)">
                        </el-table-column>
                        <el-table-column prop="width" label="尺寸(宽)">
                        </el-table-column>
                        <el-table-column prop="num" label="商品数量">
                        </el-table-column>
                        <el-table-column prop="product_price" label="总价">
                        </el-table-column>
                        <!-- <el-table-column prop="express_company" label="物流公司">
                            <template slot-scope="scope">
                                {{scope.row.express_company}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="express_no" label="物流单号">
                            <template slot-scope="scope">
                                {{scope.row.express_no}}
                            </template>
                        </el-table-column> -->
                        <!-- <el-table-column prop="status" label="审核状态" v-if="detail.role == 2">
                            <template slot-scope="scope">
                                {{scope.row.status == 40?'审核未通过' : scope.row.status == 30?'审核通过' : '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="audit_remark" label="未通过理由" v-if="detail.role == 2">
                        </el-table-column>
                        <el-table-column prop="shipping_status" label="子订单状态">
                            <template slot-scope="scope">
                                {{detail.pay_status == 0?'未支付' : '已支付'}},{{scope.row.shipping_status == 0?'未发货' : scope.row.shipping_status == 1?'已发货' : '已收货'}}
                            </template>
                        </el-table-column> -->

                    </el-table>

                   
                </el-row>
            </div>
            <div class="common-form mt16">上传源文件</div>
            <div class="table-wrap">
                <el-row>
                    <el-table :data="sourceFiles" empty-text="暂无上传源文件" style="width: 100%">
                        <el-table-column label="源文件">
                            <template slot-scope="scope">
                                {{ scope.row.original_name || scope.row.name || getFileName(scope.row.file_path) }}
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="180" >
                            <template slot-scope="scope">
                                <div style="display: flex; flex-direction: row;">
                                    <el-button
                                    size="mini"
                                    type="primary"
                                    @click="downloadFile(scope.row.file_path, scope.row.original_name || scope.row.name)"
                                    icon="el-icon-download">
                                    下载源文件
                                    </el-button>
                                </div>
                            </template>
                        </el-table-column>
                        
                    </el-table>

                   
                </el-row>
            </div>
            <div v-if="detail.status == 70">
                <div class="common-form mt16">发货信息</div>
                <el-row>
                    <el-form size="small" ref="form" :model="form" label-width="100px">
                        <el-form-item label="物流公司">
                        <el-select v-model="form.express_id" placeholder="请选择快递公司">
                            <el-option :label="item.express_name" v-for="(item, index) in expressList" :key="index" :value="item.express_id"></el-option>
                        </el-select>
                        </el-form-item>
                        <el-form-item label="物流单号">
                            <el-input v-model="form.express_no" class="max-w460"></el-input>
                        </el-form-item>
                    </el-form>
                </el-row>
                <el-row>
                    <div style="margin: 10px auto;display: flex;justify-content: center;">
                        <el-button type="primary" @click="subExpress">确认发货</el-button>
                    </div>
                </el-row>
            </div>

            <div v-if="detail.status  >70">
          <div class="common-form mt16">发货信息</div>
          <div class="table-wrap">
            <el-row>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">物流公司：</span>
                  {{detail.express_company }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">物流单号：</span>
                  {{ detail.express_no }}
                </div>
              </el-col>
              <!-- <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">发货状态：</span>
                  {{ detail.delivery_status.text }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">发货时间：</span>
                  {{ detail.delivery_time }}
                </div>
              </el-col> -->
            </el-row>
          </div>
        </div>
     
        </div>


            <!--付款信息-->
      <div class="table-wrap" v-if="detail.pay_status == 1">
        <div class="common-form mt16">付款信息</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">应付款金额：</span>
                {{ detail.total_pay_price }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">支付方式：</span>
                <span v-if="detail.pay_type == 10">余额</span> 
                <span v-if="detail.pay_type == 20">微信</span> 
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">支付流水号：</span>
                {{ detail.transaction_id }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">付款状态：</span>
    
                <span v-if="detail.pay_status == 0">待支付</span> 
                <span v-if="detail.pay_status == 1">已支付</span> 
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">付款时间：</span>
                {{ detail.payment_time }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>


             <!--订单备注-->
             <div>
                <div class="common-form mt16">订单备注</div>
                <el-row>
                    <el-col :span="10">
                        <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="detail.user_remark">
                        </el-input>
                    </el-col>
                </el-row>

            </div>



        <div class="common-button-wrapper">
       
            <div>
                <el-button size="small" type="info" @click="cancelFunc">返回上一页</el-button>
                
                
                
                <span v-if="detail.role == 1">
                         
                                    <el-button @click="passorder(detail)" v-if="detail.status == 20" type="primary"
                                        size="small" v-auth="'/plus/horder/index/detail'">审核通过</el-button>
                                    <el-button @click="refuseorder(detail)" v-if="detail.status == 20" type="primary"
                                        size="small" v-auth="'/plus/horder/index/detail'">审核拒绝</el-button>
                                    <el-button @click="cancelOrder('single',detail)" v-if="detail.status == 20"
                                        type="primary" size="small" v-auth="'/plus/horder/index/detail'">取消订单</el-button>
                                    
                                    <el-button @click="makeOrder(detail)" v-if="detail.status == 60" type="primary"
                                        size="small" v-auth="'/plus/horder/index/detail'">生产</el-button>
                                </span>
                                <!-- 门店按钮 -->
                                <span v-if="detail.role == 2">
                                    <el-button @click="republic(detail)" v-if="detail.status == 40" type="primary"
                                        size="small" v-auth="'/plus/horder/index/detail'">重新提交</el-button>
                                    <el-button @click="receiveOrder('single',detail)" v-if="detail.status == 80"
                                        type="primary" size="small" v-auth="'/plus/horder/index/detail'">确认收货</el-button>
                                    <el-button @click="cancelOrder('single',detail)" v-if="detail.status == 20"
                                        type="primary" size="small" v-auth="'/plus/horder/index/detail'">取消订单</el-button>
                                </span>
                
                
                
                
                <!-- 取消订单 -->
                <template>
                    <el-button size="small" type="danger" @click="cancelOrder('all',0)"
                        v-if="(detail.pay_status == 0 && detail.status == 20) || (detail.pay_status == 0 && detail.status == 40)">取消订单</el-button>
                </template>
                <!-- 确认收货 -->
                <!-- <template>
                    <el-button size="small" type="primary" @click="receiveOrder('all',0)"
                        v-if="detail.status == 80">确认收货</el-button>
                </template> -->
                <!-- 支付订单 -->
                <template>
                    <el-button size="small" type="primary" @click="payOrder"
                        v-if="(detail.pay_status == 0 && detail.status == 50 && detail.role == 2)">支付订单</el-button>
                </template>
                <!-- 一键发货 -->
                <!-- <template>
                    <el-button size="small" type="primary" @click="deliver(0,'all')"
                        v-if="detail.status == 70 && detail.role == 1">一键发货</el-button>
                </template> -->
                <!-- <template>
                    <el-button size="small" type="primary" @click="passorder(detail)"
                        v-if="(detail.status == 20 && detail.role == 1)">审核通过</el-button>
                </template>
                <template>
                    <el-button size="small" type="danger" @click="refuseorder(detail)"
                        v-if="(detail.status == 20 && detail.role == 1)">审核不通过</el-button>
                </template> -->
                <!-- <template>
                    <el-button size="small" type="danger" @click="delOrder(detail)"
                        v-if="((detail.status < 60 || detail.status == 100) && detail.role == 2)">删除订单</el-button>
                </template> -->
            </div>
        </div>
        <Add :open_add="open_add" :formData="secondOrder" v-if="open_add" @close="closeAdd"></Add>
        <!--选择用户-->
        <deliveryUser :storeId="Number(form.store_id)" :is_open="isOpenGetUser" :multi="false"
            @close="closeGetUserFunc"></deliveryUser>
        <!-- 生产选择日期 -->
        <el-dialog title="填写生产信息" :visible.sync="makeshow" width="30%">
            <el-form ref="form" :model="form" label-width="120px">
                <el-form-item label="预计完成时间">
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="makeDate" type="datetime" placeholder="选择预计完成时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="送货期限">
                    <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="goodsData" type="datetime" placeholder="选择预计完成时间">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            
           
            <span slot="footer" class="dialog-footer">
                <el-button @click="makeshow = false,makeDate='',goodsData= ''">取 消</el-button>
                <el-button type="primary" @click="makeConfirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import Add from './part/resubmit.vue';
    import HorderApi from '@/api/horder.js';
    // import Add from './dialog/Add.vue';
    import Supply from './Supply';
    import deliveryUser from '@/components/user/deliveryUser';
    import {
        deepClone
    } from '@/utils/base.js';
    export default {
        components: {
            Add,
            deliveryUser,
            Supply
        },
        data() {
            return {
                // 生产弹窗
                makeshow: false,
                // 生产id
                makeid: "",
                // 生产日期
                makeDate: "",
                goodsData:"",
                secondOrder: {},
                open_add: false,
                showExpress: false,
                active: 0,
                /*是否加载完成*/
                loading: true,
                /*订单数据*/
                detail: {
                    // pay_status: [],
                    // pay_type: [],
                    // delivery_type: [],
                    // user: {},
                    // address: [],
                    // product: [],
                    // order_status: [],
                    // extract: [],
                    // extract_store: [],
                    // express: [],
                    // delivery_status: [],
                    // extractClerk: [],
                    // delivery_warehouse: ''
                },
                /*是否打开添加弹窗*/
                open_add: false,
                /*一页多少条*/
                pageSize: 20,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                /*发货*/
                form: {
                    /*订单ID*/
                    express_name: '',
                    /*订单号*/
                    express_no: ''
                },
                supform: {
                    model: {
                        supply: {
                            name: '777'
                        }
                    }
                },
                forms: {
                    is_cancel: 1
                },
                extract_form: {
                    order: {
                        extract_status: 1
                    }
                },
                order: {},
                delivery_type: 0,
                /*配送方式*/
                exStyle: [],
                /*门店列表*/
                shopList: [],
                /*当前编辑的对象*/
                userModel: {},
                /*时间*/
                create_time: '',
                /*快递公司列表*/
                expressList: [],
                shopClerkList: [],
                /*是否打开编辑弹窗*/
                open_edit: false,
                supply_id: 0,
                // 选择用户flag
                isOpenGetUser: false,
                // 选择的配送员列表,只有一个
                select_list: [],
                deliveryForm: {

                },
                textarea: "",
                expressData: []
            };
        },
        computed: {
            sourceFiles() {
                let files = this.detail && this.detail.files ? this.detail.files : [];
                if (typeof files === 'string') {
                    try {
                        files = JSON.parse(files);
                    } catch (e) {
                        files = [];
                    }
                }
                if (!Array.isArray(files)) return [];

                const sourceTypes = ['source_file', 'file'];
                const sourceExtensions = ['cdr', 'ai', 'psd', 'svg', 'eps', 'pdf'];
                const paths = new Set();

                return files.filter(file => {
                    if (!file || !file.file_path || paths.has(file.file_path)) return false;
                    const type = String(file.type || '').toLowerCase();
                    const name = file.original_name || file.name || file.file_path;
                    const extension = String(name).split('?')[0].split('.').pop().toLowerCase();
                    const isSource = sourceTypes.includes(type) || sourceExtensions.includes(extension);
                    if (isSource) paths.add(file.file_path);
                    return isSource;
                });
            }
        },
        created() {
            /*获取列表*/
            this.getParams();
        },
        methods: {
            getFileName(filePath) {
                if (!filePath) return '源文件';
                return String(filePath).split('/').pop().split('?')[0] || '源文件';
            },
            // 删除订单
            delOrder() {
                let that = this
                let data = {}
                data.horder_id = that.detail.horder_id
                HorderApi.delOrder(data, true).then(res => {
                    if (res.code == 1) {
                        console.log(res)
                        if (res.code == 1) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            setTimeout(() => {
                                that.$router.back(-1);
                            }, 1000)
                        }
                    }
                })
            },
            // 打开生产弹窗
            makeOrder(e) {
                let that = this
                console.log('e,', e)
                that.makeid = e.horder_id
                that.makeshow = true
            },
            //下载文件
             downloadFile(url, fileName) {
                console.log(url,'url')
                console.log(fileName,'fileName')
                const link = document.createElement('a');
                link.href = url;
                link.download = fileName; // 设置下载文件名
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            // 确认生产
            makeConfirm(){
                let that = this
                let data = {}
                let array = []
                let tep = {}
                tep.horder_id = that.makeid
                tep.production_deadline = that.makeDate
                tep.goods_deadline = that.goodsData
                array.push(tep)
                data.params = array
                HorderApi.makeOrder(data, true).then(res => {
                    that.makeshow = false
                    that.makeDate = ""
                    that.goodsData = ""
                    that.makeid = ''
                    if (res.code == 1) {
                        if (res.code == 1) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            setTimeout(() => {
                                that.getParams()
                                
                            }, 1000)
                        }
                    }
                })
            },
            // 支付订单
            payOrder() {
                let that = this
                let data = {}
                data.horder_id = that.detail.horder_id
                data.total_pay_price = that.detail.total_pay_price
                HorderApi.payOrder(data, true).then((res) => {
                    if (res.code == 1) {
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        });
                        setTimeout(() => {
                            self.getParams()
                        }, 1000)
                    }
                })
            },

            // 订单审核不通过
            async refuseorder(item) {
                var self = this;
                const reject_val = await self.promptInput('请输入不通过的原因',
                    '请输入不通过的原因');
                console.log(reject_val)
                var self = this
                let datas = {}
                let array = []
                if (item.horder_product_id) {
                    let tep = {}
                    tep.horder_product_id = item.horder_product_id
                    tep.status = 40
                    tep.audit_remark = reject_val
                    array.push(tep)
                } else {
                    console.log(item)
                    item.children[0].children.forEach((v, i) => {
                        let te = {}
                        te.status = 40
                        te.horder_product_id = v.horder_product_id
                        te.audit_remark = reject_val
                        array.push(te)
                    })
                }
                datas.params = array
                HorderApi.passorder(datas, true).then(res => {
                    if (res.code == 1) {
                        console.log(res)
                        if (res.code == 1) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            setTimeout(() => {
                                self.getParams()
                            }, 1000)
                        }

                    }
                })
            },
            async promptInput(message, validation) {
                try {
                    const {
                        value
                    } = await this.$prompt(message, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputErrorMessage: validation,
                    });
                    return value.trim();
                } catch (e) {
                    this.$message({
                        type: 'info',
                        message: '取消输入',
                    });
                }
            },
            // 订单审核通过
            passorder(item) {
                var self = this
                let datas = {}
                let array = []
                if (item.horder_product_id) {
                    let tep = {}
                    tep.horder_product_id = item.horder_product_id
                    tep.status = 30
                    array.push(tep)
                } else {
                    console.log(item)
                    item.children[0].children.forEach((v, i) => {
                        let te = {}
                        te.status = 30
                        te.horder_product_id = v.horder_product_id
                        array.push(te)
                    })
                }
                datas.params = array
                HorderApi.passorder(datas, true).then(res => {
                    if (res.code == 1) {
                        console.log(res)
                        if (res.code == 1) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            setTimeout(() => {
                                self.getParams()
                            }, 1000)
                        }

                    }
                })
            },
            // 取消订单
            cancelOrder(type, params) {
                let that = this
                let data = {}
                if (type == 'single') {
                    let array = []
                    let tep = {}
                    tep.horder_product_id = params.horder_product_id
                    array.push(tep)
                    data.params = array
                } else {
                    let p = that.detail.children[0].children
                    let array = []
                    p.forEach((v, i) => {
                        let tep = {}
                        tep.horder_product_id = v.horder_product_id
                        array.push(tep)
                    })
                    data.params = array
                }
                HorderApi.cancelOrder(data, true).then((res) => {
                    if (res.code == 1) {
                        that.$message({
                            message: res.msg,
                            type: 'success'
                        });
                        that.getParams()
                    }
                })
            },

            // 确认收货
            receiveOrder(type, params) {
                let that = this
                let data = {}
                if (type == 'single') {
                    let array = []
                    let tep = {}
                    tep.horder_product_id = params.horder_product_id
                    array.push(tep)
                    data.params = array
                } else {
                    let p = that.detail.children[0].children
                    let array = []
                    p.forEach((v, i) => {
                        let tep = {}
                        tep.horder_product_id = v.horder_product_id
                        array.push(tep)
                    })
                    data.params = array
                }
                HorderApi.receiveOrder(data, true).then((res) => {
                    if (res.code == 1) {
                        that.$message({
                            message: res.msg,
                            type: 'success'
                        });
                        that.getParams()
                    }
                })
            },

            republic(e) {
                console.log(e)
                let that = this
                that.secondOrder = e
                that.open_add = true
            },
            closeAdd() {
                let that = this
                that.open_add = false
                this.getParams();
            },
            deliver(id, type) {
                let that = this
                that.showExpress = true
                let data = {}
                if (type == 'single') {
                    let tep = []
                    let tem = {}
                    tem.horder_id = id
                    tem.shipping_type = 1
                    tem.shipping_id = 10110
                    tem.express_company = that.form.express_name
                    tem.express_no = that.form.express_no
                    tep.push(tem)
                    data.params = tep
                } else {
                    let tep = []
                    that.detail.children[0].children.forEach((v, i) => {
                        let tem = {}
                        tem.horder_id = v.horder_product_id
                        tem.shipping_type = 1
                        tem.shipping_id = 10110
                        tem.express_company = that.form.express_name
                        tem.express_no = that.form.express_no
                        tep.push(tem)
                        data.params = tep
                    })
                }
                that.expressData = data
            },
            subExpress() {
                let that = this
                that.form.horder_id = that.detail.horder_id
                HorderApi.deliverGoods( that.form, true).then((res) => {
                    if (res.code == 1) {
                        that.$message({
                            message: res.msg,
                            type: 'success'
                        });
                        that.getParams()
                    }
                })
            },
            timestampToTime(timestamp) {
                if (timestamp) {
                    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                    var Y = date.getFullYear() + '-';
                    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                    var D = date.getDate() + ' ';
                    var h = date.getHours() + ':';
                    var m = date.getMinutes() + ':';
                    var s = date.getSeconds();
                    return Y + M + D + h + m + s;
                } else {
                    return "-"
                }

            },
            next() {
                if (this.active++ > 4) this.active = 0;
            },
            /*获取参数*/
            // sorderDetail
            // detail


            getParams() {
                let self = this;
                let role = this.$route.query.role
                let params = this.$route.query.order_id
                let type = this.$route.query.type
                // 请求总订单接口
                if (type == 1) {
                    let data = {}
                    data.horder_id = params
                    HorderApi.detail(data, true).then((res) => {
                  
                        if (res.code == 1) {
                            self.loading = false;
                            self.detail = res.data.data
                            self.expressList = res.data.expressList;
                        }
                    })
                } else {
                    // 请求子订单接口
                    let data = {}
                    data.horder_product_id = params
                    HorderApi.detail(data, true).then((res) => {
                        console.log("detial2", res)
                        self.loading = false;
                        self.detail = res.data
                    })
                }

                // if(role == 2){
                //     HorderApi.sorderDetail({
                //             horder_product_id: params,
                //         },true).then(res => {
                //             self.loading = false;
                //            console.log(res)
                //            if(res.code == 1){
                //                self.detail = res.data
                //            }
                //         })
                //         .catch(error => {
                //             self.loading = false;
                //         });
                // }
                // 取到路由带过来的参数
                // const params = this.$route.query.order_id;
                // OrderApi.orderdetail({
                //         order_id: params,
                //         XDEBUG_SESSION_START: 'PHPSTORM',
                //     }).then(data => {
                //         self.loading = false;
                //         self.detail = data.data.detail;
                //         self.expressList = data.data.expressList;
                //         self.shopClerkList = data.data.shopClerkList;

                //         if (data.data.supply) {
                //             self.supply = data.data.supply;
                //             self.supply_id = self.supply.supply_id;
                //             self.supply_setting = data.data.supply.kmd_grade.setting;
                //         } else {

                //         }
                //     })
                //     .catch(error => {
                //         self.loading = false;
                //     });
            },
            // 确认线下支付
            onSubmitPay() {
                let self = this;
                let param = self.form;
                let order_id = this.$route.query.order_id;
                self
                    .$confirm('客户线下是否已经支付?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                    .then(() => {
                        OrderApi.surePay({
                                    param: param,
                                    order_id: order_id
                                },
                                true
                            )
                            .then(data => {
                                self.loading = false;
                                self.$message({
                                    message: '恭喜你，确认支付成功',
                                    type: 'success'
                                });
                                self.getParams();
                            })
                            .catch(error => {
                                self.loading = false;
                            });
                    })
                    .catch(() => {});

            },
            /*发货*/
            onSubmit() {
                let self = this;
                let param = self.form;
                if (param.express_id == null) {
                    this.$message.error('请选择物流公司');
                    return;
                }
                if (param.express_no == '') {
                    this.$message.error('请填写物流单号');
                    return;
                }
                let order_id = this.$route.query.order_id;
                OrderApi.delivery({
                            param: param,
                            order_id: order_id
                        },
                        true
                    )
                    .then(data => {
                        self.loading = false;
                        self.$message({
                            message: '恭喜你，发货成功',
                            type: 'success'
                        });
                        self.getParams();
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },

            /*确认取消*/
            confirmCancel() {
                let self = this;
                let order_id = this.$route.query.order_id;
                let is_cancel = self.forms.is_cancel;
                OrderApi.confirm({
                            order_id: order_id,
                            is_cancel: is_cancel
                        },
                        true
                    )
                    .then(data => {
                        self.loading = false;
                        self.$message({
                            message: '恭喜你，审核成功',
                            type: 'success'
                        });
                        self.getParams();
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },

            /*核销*/
            onExtract(e) {
                let self = this;
                let extract_form = self.extract_form;
                extract_form.order_id = e;
                OrderApi.extract({
                            extract_form
                        },
                        true
                    )
                    .then(data => {
                        self.loading = false;
                        self.$message({
                            message: '恭喜你，操作成功',
                            type: 'success'
                        });
                        self.getParams();
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },

            /*打开编辑*/
            editClick(item) {
                this.userModel = deepClone(item);
                this.open_edit = true;
            },

            /*关闭弹窗*/
            closeDialogFunc(e, f) {
                if (f == 'edit') {
                    this.open_edit = e.openDialog;
                    this.getParams();
                }
            },

            /*取消*/
            cancelFunc() {
                this.$router.back(-1);
            },
            /*打开获取用户*/
            openGetUser() {
                this.isOpenGetUser = true
            },
            /*关闭获取用户*/
            closeGetUserFunc(e) {
                if (e.type != 'error') {
                    this.select_list = [e.params]
                }
                this.isOpenGetUser = false
            },
            // 确认配送
            confirmDelivery() {
                // select_list
                // if (!Array.isArray(this.select_list)) {
                //   this.$message.error('请选择配送员')
                //   return false
                // }
                // if (this.select_list.length === 0) {
                //   this.$message.error('请选择配送员')
                //   return false
                // }
                let self = this;
                let order_id = this.$route.query.order_id;
                // let deliveryStaffId = self.select_list[0].delivery_staff_id;
                OrderApi.deliveryStaff({
                    order_id: order_id,
                    // deliveryStaffId: deliveryStaffId,
                    // XDEBUG_SESSION_START: 'PHPSTORM',
                }).then(data => {
                    self.loading = false;
                    self.$message({
                        message: '配送成功',
                        type: 'success'
                    });
                    self.getParams()
                }).catch(error => {
                    self.loading = false;
                })
            },

        }
    };
</script>
<style scoped>

.image-error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #909399;
}

.image-error i {
    font-size: 50px;
    margin-bottom: 20px;
}

/* 操作按钮间距 */
.el-button + .el-button {
    margin-left: 8px;
}

/* 对话框图片容器 */
.el-image {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/horder/index/detail.vue